<script>
import Layout from "@/views/layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal";
import LogTable from "@/components/standard/ResponsibleSGSST/ResponsibleLogTable";
import Table from "@/components/standard/ResponsibleSGSST/components/ResponsibleTable";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import ItemAPI from "@/services/items/itemsAPI";
import revised_objetivesAPI from "@/services/standards/revised_objetives/revised_objetivesAPI";
import Pagination from "@/components/standard/revised_objectives/revised_objectivesPagination"

export default {
  page: {
    title: "2.2.1 Objetivos del SG SST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    LogTable,
    Table,
    CheckModal,
    Pagination
  },
  data() {
    return {
      title: "2.2.1 Objetivos del SG SST",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Objetivos definidos",
          active: true,
        },
      ],

      submitted: false,

      itemData: null,

      item: null,
      itemStatus: "No cumplido",

      userSelected: null,
      usersList: [],

      list: [],
      lista: [],
      deleteCount: 0,

      company: "",
      search: "",

      employeeDesignSST: "",

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      company: this.$store.getters["company/getCompany"] || null,
      user: this.$store.state.auth || null,

      loading: true,
      loading2: true,
    };
  },
  methods: {

    fetch() {
      this.$refs.paginator.query();
    },

    getList() {
      revised_objetivesAPI.get(this.companyID)
        .then((response) => {
          this.loading = false;
          this.lista = response.data.data;
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getItemData() {
      ItemAPI.getItems(13)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     */
    sendNotification(messageID, itemID) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        company.id_diseno_sso,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    goBack() {
      this.$router.go(-1);
    },

    goPage(url) {
      window.location.href = url;
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 13)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
      this.loading2 = false;
    },

    deleteIdentification(id) {
      revised_objetivesAPI
        .deleteIdentification(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 13,
            status: newStatus,
          };

          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Se ha eliminado con éxito!",
                icon: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              setTimeout(() => window.location.reload(), 2000);
            })
            .catch((error) => {
              Swal.fire({
                title: "¡ERROR!",
                text: "¡No se ha actualizado el estado del ítem!",
                icon: "error",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              setTimeout(() => window.location.reload(), 2000);
              console.log(error);
            });

        })
        .catch((error) => {
          console.log(error);
        });
    },


    changeItemStatus(itemStatus) {
        const itemChange = {
          companies_id: this.companyID,
          item_id: 13,
          status: itemStatus,
        };
        newScoresAPI.calculateScores(itemChange)
          .then((response) => {
            Swal.fire({
              title: "¡Éxito!",
              text: "¡Se ha cambiado el estado del ítem con éxito!",
              icon: "success",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            setTimeout(() => window.location.reload(), 2000)
          })
          .catch((error) => {
            Swal.fire({
              title: "¡ERROR!",
              text: "¡No se ha actualizado el estado del ítem!",
              icon: "error",
              confirmButtonClass: "btn btn-confirm mt-2",
            });

            setTimeout(() => window.location.reload(), 2000)
            console.log(error);
          });

    },
  },

  mounted() {
    this.getItems();
    this.getItemData();
    this.getList()
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">

        <div v-if="!loading2">
          <div class="card">

            <div class="card-body">
              <div class="row">

                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">
                      La empresa debe definir unos objetivos en SST que permitan darle cumplimiento a la política.

                      Estos objetivos deben expresar los propósitos que tiene la empresa con el SG SST, deben ser
                      redactados de manera clara, concisa, deben ser cuantificables, compatibles y coherentes.

                      A cada objetivo se le deben definir unas metas y un indicador que permita medir el resultado, el
                      cual será presentado a la Gerencia en la Revisión por la Dirección.
                    </p>

                  </CheckModal>
                </div>
                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>

              </div>

              <div class="row">
                <div class="col-lg-12">
                  <div class="card-body">

                    <div class="row">
                      <div class="col-12 text-right">
                        <button type="button" :disabled="!getRole('Crear') || !allowAccess()" class="btn btn-primary"
                          @click="goPage(`/forms/estandares/objetivos-definidos-registro`)">
                          Agregar
                        </button>
                      </div>
                    </div>

                    <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                      <div class="col-lg-12">
                        <div class="card-body">
                          <div class="row pb-3 px-2">
                            <div class="col-6">
                              <form @submit.prevent="fetch()" class="form-inline">
                                <div class="form-group mr-2">
                                  <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                    class="form-control px-2" placeholder="Buscar"></b-form-input>

                                  <div class="col-1">
                                    <button type="submit" class="btn btn-primary px-2">
                                      Buscar
                                    </button>
                                  </div>
                                </div>
                              </form>
                            </div>
                            <div class="col-6"></div>
                          </div>

                          <div class="table-responsive">
                            <table class="
                            pt-2
                            table
                            border-bottom
                            divide-y divide-gray-200
                            table-striped
                            rounded
                          ">
                              <thead>
                                <tr>
                                  <th class="text-center align-middle">Objetivo</th>
                                  <th class="text-center align-middle">Frecuencia</th>
                                  <th class="text-center align-middle">Indicador</th>
                                  <th class="text-center align-middle">Estado</th>
                                  <th class="text-center align-middle">Acciones</th>
                                </tr>
                              </thead>
                              <tbody class="bg-white divide-y divide-gray-200">
                                <tr v-for="dato in lista" :key="dato.id">
                                  <td class="text-center align-middle">{{ dato.objective }}</td>
                                  <td class="text-center align-middle">
                                    {{ dato.frequency }}
                                  </td>
                                  <td class="text-center align-middle">
                                    {{ dato.indicator }}
                                  </td>

                                  <td class="text-center align-middle">
                                    <div v-if="dato.status == 1">
                                      <h6>Activo
                                      </h6>
                                    </div>
                                    <div v-else="dato.status == 0">
                                      <h6>Inactivo
                                      </h6>
                                    </div>
                                  </td>

                                  <td class="text-center align-middle">
                                    <div class="col-sm-12">
                                      <b-dropdown :disabled="!getRole('Editar') || !allowAccess()" variant="primary">
                                        <template v-slot:button-content>
                                          <i class="mdi mdi-eye"></i>
                                        </template>
                                        <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()"
                                          :to="{ path: `/forms/estandares/objetivos-definidos-editar/${dato.id}` }">
                                          Editar</b-dropdown-item>
                                        <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()"
                                          v-on:click="deleteIdentification(dato.id)">Eliminar</b-dropdown-item>
                                        <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()"
                                          :to="{ path: `/forms/estandares/seguimiento-objetivos/${dato.id}` }">
                                          Seguimiento</b-dropdown-item>
                                      </b-dropdown>
                                    </div>
                                  </td>
                                </tr>


                              </tbody>
                            </table>
                            <div>
                              <Pagination ref="paginator" @fetch="(items) => (lista = items)"
                                @loading="(load) => (loading = load)" :search="search" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- end col -->
                    </div>


                  </div>
                </div>
                <!-- end col -->
              </div>
            </div>
          </div>

        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>